<script setup>
import { ref } from 'vue'
import BackButton from '@/src/vueComponent/BackButton.vue'
import { SendOutlined } from '@ant-design/icons-vue'

import mySwal from '@/src/javascripts/plugins/mySwal.js'

const emit = defineEmits(['submitForm'])

const documentData = ref({
  sign_action: '',
  suggestion: ''
})

const submitForm = () => {
  if (documentData.value.action === '') {
    mySwal.fire({
      title: '請選擇回覆動作'
    })
    return false
  } else {
    emit('submitForm', documentData.value)
  }
}
</script>
<template>
  <form @submit.prevent="submitForm" class="leave-need-confirm">
    <div class="w3-card-2 my-4 rounded-md border border-solid p-4">
      <h3>回覆</h3>
      <table class="w3-table">
        <tbody>
          <tr>
            <th class="align-middle md:w-1/3" style="width: 20rem">動作</th>
            <td>
              <div class="container flex flex-wrap">
                <input
                  type="radio"
                  name="sign_action"
                  id="sign_action_sign"
                  value="read"
                  required="required"
                  class="hidden"
                  v-model="documentData.sign_action"
                />
                <label
                  for="sign_action_sign"
                  class="m-2 cursor-pointer rounded-md border border-solid border-scp-royal-blue px-4 py-1 text-scp-royal-blue"
                  :class="{ 'bg-scp-royal-blue text-white': documentData.sign_action === 'read' }"
                >
                  已讀
                </label>
              </div>
            </td>
          </tr>
          <tr>
            <th class="align-middle">備註</th>
            <td>
              <textarea
                name="suggestion"
                id="suggestion"
                row="5"
                class="textarea w-full border border-gray-300"
                v-model="documentData.suggestion"
              ></textarea>
            </td>
          </tr>
        </tbody>
      </table>
    </div>
    <div class="flex items-center justify-end gap-3 py-3">
      <BackButton :hasForm="true" :returnPath="'/documents'" />
      <button type="submit" class="btn btn-success text-xl text-white">
        <SendOutlined />
        送出
      </button>
    </div>
  </form>
</template>
<style lang="scss" scoped></style>
